import DataDisplayRowI from "./DataDisplayRowI";
import DataDisplayTableI from "./DataDisplayTableI";

abstract class DataDisplayTable implements DataDisplayTableI {
    #row!: DataDisplayRowI

    create(type?: string): DataDisplayRowI {
        this.#row = this.generateRow(type);
        if (!this.#row)
            throw new TypeError("Null row was returned")
        return this.#row
    }

    /**
     * The factory method to determine the type of row to be returned
     * @param type An enum string defined within a DataDisplayTable sub-class to determine the type of row to be instantiated. 
     * @returns A data display row singleton
     */
    abstract generateRow(type?: string): DataDisplayRowI
}

export default DataDisplayTable;